const HOME_PATH = '/';
const PL_PATH = '/personal-loans/';
const CH_PATH = '/credit-health-monitoring/';
const PR_PATH = '/press/';
const AB_PATH = '/about/';
const AR_PATH = '/auto-refi/';
const UPGRADE_CARD_PATH = '/upgrade-card/';
const REWARDS_CHECKING_PLUS_PATH = '/rewards-checking-plus/';
const ATM_NETWORK_PATH = `${REWARDS_CHECKING_PLUS_PATH}ATMS/`;
const SWITCH_KIT_PATH = `${REWARDS_CHECKING_PLUS_PATH}switch/`;
const PREMIER_SAVINGS_PATH = '/premier-savings/';
const CAREERS_PATH = '/careers/';
const REVIEWS_PATH = '/reviews/';
const CREDIT_HEALTH_INSIGHTS_PATH = '/credit-health/insights/';
const SECURITY_PATH = '/security/';
const ACCESSIBILITY_PATH = '/accessibility/';
const HOME_IMPROVEMENT_PATH = '/home-improvement/';
const AUTO_FINANCE_DEALER_PATH = '/auto-finance-dealer/';
const AUTO_FINANCE_CUSTOMER_PATH = '/auto-finance/';
const AUTO_REFI_PATH = '/auto-refi/';
const PL_RCC_PATH = `${PL_PATH}refinance-credit-cards/`;
const PL_DC_PATH = `${PL_PATH}debt-consolidation/`;
const PL_HI_PATH = `${PL_PATH}home-improvement/`;
const PL_MP_PATH = `${PL_PATH}major-purchase/`;
const PL_UE_PATH = `${PL_PATH}unexpected-expense/`;
const PCL_ONE_CARD_PATH = '/one-card/';
const PCL_SELECT_CARD_PATH = '/upgrade-card/select-card/';
const PCL_LIFE_CARD_PATH = '/upgrade-card/life-rewards/';
const PCL_CASH_CARD_PATH = '/upgrade-card/cash-rewards/';
const PCL_TRIPLE_CASH_PATH = '/upgrade-card/triple-cash/';
const DIRECTORY_PATH = '/portal/directory';
const DEPOSIT_PATH = '/deposit';
const FLEX_PAY = '/flex-pay/';
const FLEX_PAY_FIND_PARTNERS = `${FLEX_PAY}find-partners/`;
const FLEX_PAY_PARTNERS = `${FLEX_PAY}partners/`;
const PRESS = '/press/';
const PRESS_MEMOS = '/press/memos/';
const PRESS_MEDIA_ASSETS = '/press/media-assets/';
const PRESS_NEWS = '/press/in-the-news/';

module.exports = {
  HOME_PATH,
  ATM_NETWORK_PATH,
  PL_PATH,
  CH_PATH,
  PR_PATH,
  AB_PATH,
  AR_PATH,
  UPGRADE_CARD_PATH,
  REWARDS_CHECKING_PLUS_PATH,
  PREMIER_SAVINGS_PATH,
  CAREERS_PATH,
  REVIEWS_PATH,
  CREDIT_HEALTH_INSIGHTS_PATH,
  SECURITY_PATH,
  ACCESSIBILITY_PATH,
  HOME_IMPROVEMENT_PATH,
  AUTO_FINANCE_DEALER_PATH,
  AUTO_FINANCE_CUSTOMER_PATH,
  AUTO_REFI_PATH,
  PL_RCC_PATH,
  PL_DC_PATH,
  PL_HI_PATH,
  PL_MP_PATH,
  PL_UE_PATH,
  PCL_ONE_CARD_PATH,
  PCL_SELECT_CARD_PATH,
  PCL_LIFE_CARD_PATH,
  PCL_CASH_CARD_PATH,
  PCL_TRIPLE_CASH_PATH,
  DIRECTORY_PATH,
  DEPOSIT_PATH,
  FLEX_PAY,
  FLEX_PAY_FIND_PARTNERS,
  FLEX_PAY_PARTNERS,
  PRESS,
  PRESS_MEMOS,
  PRESS_MEDIA_ASSETS,
  PRESS_NEWS,
  SWITCH_KIT_PATH
};
